/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setPushToStartLiveActivityToken} from '../api'

export const useMutationSetPushToStartLiveActivityToken = createReactQueryMutationHook('setPushToStartLiveActivityToken', setPushToStartLiveActivityToken)
